import React from 'react'

// Chart-type picker thumbnail: four overlapping distribution ridges. Drawn at
// the same 72x56 size and palette as the other freeform chart-type icons.
export const RidgelineIcon: React.FC = () => (
  <svg
    width="72"
    height="56"
    viewBox="0 0 72 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="72" height="56" rx="4" fill="white" />
    <path
      d="M26 18C35 18 35 8 44 8C53 8 53 18 62 18Z"
      fill="#DCE3ED"
      stroke="#4F72A4"
      strokeWidth="1"
    />
    <path
      d="M14 28C24 28 24 16 34 16C44 16 44 28 54 28Z"
      fill="#95AAC8"
      stroke="#4F72A4"
      strokeWidth="1"
    />
    <path
      d="M28 38C37 38 37 27 46 27C55 27 55 38 64 38Z"
      fill="#DCE3ED"
      stroke="#4F72A4"
      strokeWidth="1"
    />
    <path
      d="M10 48C19 48 19 37 28 37C37 37 37 48 46 48Z"
      fill="#95AAC8"
      stroke="#4F72A4"
      strokeWidth="1"
    />
  </svg>
)
